import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBmcsoftwareComponent } from './simple-icons-bmcsoftware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBmcsoftwareComponent ],
    exports:      [ SimpleIconsBmcsoftwareComponent ],
    bootstrap:    []
})
export class SimpleIconsBmcsoftwareModule {}
